import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCs7WZUm5JIl8EZBvpHvqHrMkoY8qkJVHI",
  authDomain: "edc-darts-cbe6a.firebaseapp.com",
  projectId: "edc-darts-cbe6a",
  storageBucket: "edc-darts-cbe6a.firebasestorage.app",
  messagingSenderId: "607794825011",
  appId: "1:607794825011:web:14028c1e20540254516046",
  measurementId: "G-JCXR0PZH8P"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
